// DatenschutzErklaerungTyp.ts
export enum DataPrivacyPolicyStatus {
  NOT_INFORMED = "NICHT_INFORMIERT",
  INFORMED_VIA_POSTER = "HINWEIS_AUSHANG_WEBSITE",
  SIGNED = "UNTERSCHRIEBEN"
}
